import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=0fefed62&scoped=true&"
import script from "./Lottery.vue?vue&type=script&lang=js&"
export * from "./Lottery.vue?vue&type=script&lang=js&"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=0fefed62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefed62",
  null
  
)

export default component.exports